<template>
  <div
    :style="{
      marginBottom: '10px',
      borderRadius: level === 0 ? '10px' : '0',
      marginLeft: level !== 0 ? '' : '10px',
      ...(level === 0 ? { border: '1px solid #ccc' } : { borderLeft: '3px solid #ccc' }),
    }"
  >
    <div>
      <!-- Avatar + Content -->
      <div>
        <div style="display: flex; gap: 10px; flex: 1; padding: 10px">
          <!-- Avatar -->
          <div class="icon-block initial" style="flex-shrink: 0">
            <div v-if="entityUserInfoData[comment.created_by]?.avatar">
              <img
                :src="entityUserInfoData[comment.created_by].avatar"
                alt="IMG"
                width="30"
                height="30"
                style="border-radius: 50%"
              />
            </div>
            <div class="icon" v-else>
              <div class="initial-text">
                <span>{{ getInitials(comment) }}</span>
              </div>
            </div>
          </div>

          <!-- Name + Date + Comment -->
          <div style="flex: 1">
            <div style="display: flex; align-items: center; gap: 6px">
              <div v-if="level >= 1" class="text-xs text-gray-500">↳</div>
              <div class="flex !gap-2">
                <span class="text-black-950 text-xs xl:text-smd 2xl:!text-sm">
                  {{
                    comment.created_by === getAuthenticatedUser._id
                      ? 'You'
                      : entityUserInfoData[comment.created_by]?.first_name +
                        ' ' +
                        entityUserInfoData[comment.created_by]?.last_name
                  }}
                </span>
                <span class="text-black-500 text-xs 2xl:text-smd font-normal">
                  {{ comment.created_at | getFormattedDateTypeThree }}
                </span>
              </div>
            </div>
            <p
              class="text-black-700 text-xs 2xl:text-smd font-normal !mt-2"
              v-html="comment.comment"
            ></p>
            <!-- Reply Button -->
          </div>
        </div>
        <div
          class="flex items-center justify-start !gap-4 !border-y !border-black/10 !py-2 !px-4 !mb-2"
        >
          <!-- View Replies Button -->

          <span
            class="flex items-center !gap-1 text-xxs xl:!text-xs 2xl:text-smd !font-normal cursor-pointer"
            style="color: #828282; cursor: pointer"
            @click="replyToComment(comment._id)"
          >
            <img src="@/assets/img/icons/new/reply-icon.svg" alt="" class="!size-3" />
            <span>Reply</span>
          </span>
          <div v-if="comment.replies?.length">
            <button
              class="!text-blue-500 text-xxs xl:!text-xs 2xl:text-smd"
              @click="toggleReplies"
              style="background: none; border: none; cursor: pointer; padding: 0"
            >
              {{ showReplies ? 'Hide Replies' : `View Replies (${comment.replies.length})` }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Recursive Nested Replies -->
    <div v-if="showReplies">
      <CommentBlock
        v-for="reply in comment.replies"
        :key="reply._id"
        :comment="reply"
        :entityUserInfoData="entityUserInfoData"
        :level="level"
        @reply="replyToComment"
      />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'CommentBlock',
    props: {
      comment: Object,
      entityUserInfoData: Object,
      level: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        showReplies: false,
      };
    },
    computed: {
      ...mapGetters('auth', ['getAuthenticatedUser']),
    },
    methods: {
      toggleReplies() {
        this.showReplies = !this.showReplies;
      },
      getInitials(comment) {
        const firstName = this.entityUserInfoData[comment.created_by]?.first_name || '';
        const lastName = this.entityUserInfoData[comment.created_by]?.last_name || '';
        return (firstName[0]?.toUpperCase() || '') + (lastName[0]?.toUpperCase() || '');
      },
      replyToComment(commentId) {
        this.$emit('reply', commentId);
      },
    },
  };
</script>
